/* eslint-disable arrow-body-style */

import React, { useEffect, useState } from 'react';
import Select from 'react-select'
import styled, { css } from 'styled-components';
import { Box, ListItem, InvalidText } from 'styles';
import {InputLabel} from "./inputLabel/InputLabel";

export function FormikSelectWithSearch({ invalid, showValid, touched, label, path, $require,...props }) {
  const [invalidValue, setInvalidValue] = useState(null);
  const [invalidText, setInvalidText] = useState(null);

  useEffect(() => {
      console.log('----------------------');
      console.log(invalid);
      console.log(showValid);
      console.log(touched);
    if (touched && invalid && invalid.length > 0) {
      setInvalidValue('error');
    } else if (touched && showValid && !invalid) {
      setInvalidValue('success');
    } else {
      setInvalidValue(null);
    }

      setInvalidText((touched && invalid && invalid.length > 0)? invalid : '');
  }, [invalid, showValid, touched]);

  return (
      <Container>
          {label && <InputLabel path={path} label={label} require={$require}></InputLabel>}
        <Select {...props}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    padding: '2px 10px',
                    fontSize: '14px',
                    lineHeight: '1.5',
                    borderRadius: '8px',
                    border: invalidValue !== 'error' ? '2px solid #E6E6E6' : '2px solid #CC3535',
                  }),
                }}
        />
        {invalidValue === 'error' && <InvalidText $color="error">{invalidText}</InvalidText>}
      </Container>
  );
}


const Container = styled(Box)`
  position: relative;
  ${({ $flex }) => $flex && `flex=${$flex}`};

  & > label > .hidden-input {
    border: 0;
    clip: rect(0 0 0 0);
    height: 0px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 0px;
  }
`;

